<template>
  <el-container>
    <el-header height="90px">
      <div class="wrapper_content">
        <div class="header_handle">
          <div>
            <div class="site_logo">
              <router-link to="/"><img :src="$logoPath" /></router-link>
            </div>
            <router-link to="/" class="back_home no_ico">返回首页</router-link>
            <!-- <a class="back_home no_ico" href="/">返回首页</a> -->
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </el-header>
    <div class="member_con">
      <div class="left"><img src="@/assets/newImg/login_left.jpg" alt="" /></div>
      <div :class="isBoss ? 'my_member2 company_1' : 'my_member2'">
        <div class="sign-wrap-v2">
          <div class="sign-form sign-register">
            <div class="sign-content">
              <div class="inner-box">
                <slot></slot>
              </div>
              <slot name="sao"></slot>
            </div>
          </div>
        </div>
      </div>
      <div class="right"><img src="@/assets/newImg/login_right.jpg" alt="" /></div>
    </div>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: 'ComLogin',
  components: {
    Footer: () => import('@/layout/components/Footer')
  },
  props: {
    height: {
      type: Number,
      default: 700
    },
    isBoss: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.member_con {
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
  /* padding: 97px 0; */
}
.member_con .left {
  width: calc(50% - 600px);
  float: left;
  height: 694px;
}
.my_main2 {
  background-color: transparent;
  padding: 0;
  overflow: visible;
}
.member_con .right {
  width: calc(50% - 600px);
  float: right;
  height: 694px;
}
.company_1 {
  background: url(@/assets/newImg/login_1.jpg) no-repeat 50% !important;
}
.my_member2 {
  width: 1200px;
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
  background: url(@/assets/newImg/login_2.jpg) no-repeat 50%;
}

.sign-wrap-v2 {
  position: absolute;
  top: 50%;
  right: 5%;
  transform: translate(-50%, -50%);
}

.sign-wrap-v2 .sign-form {
  width: 100%;
  height: 580px;
  padding: 0;
  background: #fff;
  box-shadow: 0 6px 13px 0 rgb(0 0 0 / 10%);
  border-radius: 10px;
  position: relative;
}

.sign-wrap-v2 .sign-content {
  position: relative;
  padding: 0px 30px;
  height: 100%;
}

.sign-wrap-v2 .sign-register .inner-box {
  padding-top: 74px;
}

.sign-wrap-v2 .sign-form .inner-box {
  position: relative;
  width: 324px;
  margin: 0 auto;
}
.wrapper_content {
  width: 1200px;
  margin: 0 auto;
}
.wrapper_content .header_handle {
  width: 100%;
  height: 90px;
  position: relative;
}
.wrapper_content .header_handle .site_logo {
  position: relative;
  float: left;
  width: auto;
  height: 90px;
}
.wrapper_content .header_handle .site_logo a:before {
  content: '';
  position: absolute;
  left: -100px;
  top: 35px;
  width: 80px;
  height: 10px;
  background-color: hsla(0, 0%, 100%, 0.5);
  transform: rotate(-45deg);
  animation: searchLights 1.5s ease-in 1s infinite;
  z-index: 99;
}
@keyframes searchLights {
  0% {
    left: -80px;
    top: 35px;
  }
  100% {
    left: 180px;
    top: 35px;
  }
}
.wrapper_content .header_handle .site_logo img {
  max-width: 265px;
  max-height: 70px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
}
.wrapper_content .header_handle .back_home.no_ico {
  background: none;
  padding-left: 0;
  float: right;
  font-size: 14px;
  color: #333;
  padding: 2px 0 2px 23px;
  display: block;
  margin-top: 27px;
}

.sign-wrap-v2 h4 {
  margin: 0px 0 25px;
  line-height: 22px;
  color: #00c48a;
  font-size: 16px;
  font-weight: 400;
}

.sign-miniapp {
  text-align: center;
}

.qrcodeimg-box {
  display: block;
  width: 200px;
  height: 200px;
  margin: 0 auto;
  position: relative;
}

.sign-miniapp .qrcodeimg-box img {
  width: 200px;
}

.invalid-box {
  display: none;
  width: 200px;
  height: 200px;
  margin: 0 auto;
  text-align: center;
  background: rgba(255, 255, 255, 0.9);
  position: absolute;
  left: 0;
  top: 0;
}

.sign-miniapp .sign-tip {
  margin-top: 30px;
  color: #61687c;
  line-height: 22px;
}

.sign-slide-box .logo {
  float: none;
  display: block;
  width: auto;
  height: 40px;
  margin: 88px 0 0 40px;
  padding: 0;
}

.sign-slide-box .logo img {
  width: 42px;
  height: 42px;
  float: left;
}

.sign-slide-box .logo div {
  float: left;
  position: relative;
  bottom: -1px;
  margin-left: 10px;
}

.sign-slide-box .logo p {
  color: #00c48a;
  line-height: 20px;
  margin: auto;
}

@media screen and (max-width: 768px) {
  .wrapper_content {
    width: 100% !important;
  }
  .member_con .right {
    width: 100% !important;
  }
  .sign-wrap-v2 .sign-content {
    margin-left: 0px !important;
  }

  .sign-wrap-v2 {
    width: 100% !important;
    margin: 0px !important;
    top: 0px !important;
    left: 0 !important;
    transform: none !important;
    height: 100vh;
  }

  .sign-wrap-v2 .sign-form {
    width: 100%;
    height: 100%;
    border-radius: 0px;
  }
  .logo a {
    display: block;
    width: 130px;
    height: 50px;
    background: url('../assets/image/926.png') 3px 7px no-repeat;
  }
}
</style>
